/*
 * Product gallery dots on phones (sections/product.liquid with the mobile "Slider" gallery).
 * The theme shows the photos as a horizontal swipe carousel without an indicator; this adds
 * small dots under it that follow the swipe. The dots also steer the gallery: tap a dot to jump to
 * that photo, or slide a finger along the dots to run through the photos.
 * Styles in assets/custom.css (.ll-gallery-dots).
 */
(function () {
  function setup(list) {
    if (list.llDots) return;
    var slides = Array.prototype.filter.call(list.children, function (el) {
      return el.classList.contains('product__slide');
    });
    if (slides.length < 2) return;
    list.llDots = true;

    var dots = document.createElement('ol');
    dots.className = 'll-gallery-dots';
    dots.setAttribute('aria-hidden', 'true');
    slides.forEach(function () { dots.appendChild(document.createElement('li')); });
    list.insertAdjacentElement('afterend', dots);

    function update() {
      var listLeft = list.getBoundingClientRect().left;
      var best = 0;
      var bestDist = Infinity;
      slides.forEach(function (slide, i) {
        var dist = Math.abs(slide.getBoundingClientRect().left - listLeft);
        if (dist < bestDist) { bestDist = dist; best = i; }
      });
      // At the very end of the scroll the last photo is the one in view
      if (list.scrollLeft + list.clientWidth >= list.scrollWidth - 4) best = slides.length - 1;
      Array.prototype.forEach.call(dots.children, function (dot, i) {
        dot.classList.toggle('is-active', i === best);
      });
    }

    // Dots as a scrubber: tap or slide a finger along them
    function go(i, smooth) {
      var slide = slides[i];
      if (!slide) return;
      var left = list.scrollLeft + slide.getBoundingClientRect().left - list.getBoundingClientRect().left;
      list.scrollTo({ left: left, behavior: smooth ? 'smooth' : 'auto' });
    }

    function dotAt(x) {
      var best = 0;
      var bestDist = Infinity;
      Array.prototype.forEach.call(dots.children, function (dot, i) {
        var r = dot.getBoundingClientRect();
        var dist = Math.abs(r.left + r.width / 2 - x);
        if (dist < bestDist) { bestDist = dist; best = i; }
      });
      return best;
    }

    var scrubbing = false;
    var lastDot = -1;
    var startX = 0;
    dots.addEventListener('pointerdown', function (event) {
      scrubbing = true;
      startX = event.clientX;
      lastDot = dotAt(event.clientX);
      if (dots.setPointerCapture) dots.setPointerCapture(event.pointerId);
    });
    dots.addEventListener('pointermove', function (event) {
      if (!scrubbing) return;
      var i = dotAt(event.clientX);
      if (i !== lastDot) {
        lastDot = i;
        go(i, false);
      }
    });
    function endScrub(event) {
      if (!scrubbing) return;
      scrubbing = false;
      // A tap (no real movement): smooth jump to the tapped dot
      if (Math.abs(event.clientX - startX) < 6) go(dotAt(event.clientX), true);
    }
    dots.addEventListener('pointerup', endScrub);
    dots.addEventListener('pointercancel', function () { scrubbing = false; });

    var raf = null;
    list.addEventListener('scroll', function () {
      if (raf) return;
      raf = requestAnimationFrame(function () { raf = null; update(); });
    }, { passive: true });
    update();
  }

  function run() {
    document.querySelectorAll('.product__images--mobile-slider .product__slides').forEach(setup);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', run);
  else run();
  document.addEventListener('shopify:section:load', run);
})();
